export default __webpack_public_path__ + "static/media/googleLogo.ca838ff3.png";